export type FilterValue = string | number | null | undefined | readonly string[];

/**
 * The single rule for turning one filter value into its URL string: an array
 * comma-joins its entries, a scalar passes through, and an empty array, null,
 * undefined, or empty string encodes to `null` meaning "omit this param".
 * The table-filter store's `updateFilterValue` / `updateMultiSelectFlatFilter`
 * and `encodeFilterParams` both go through here, so a link built off-store and
 * the URL the filter bar writes can't encode the same value two different ways.
 */
export function encodeFilterValue(value: FilterValue): string | null {
  if (Array.isArray(value)) return value.length > 0 ? value.join(',') : null;
  if (value === null || value === undefined || value === '') return null;
  return String(value);
}

/** Encodes a set of filter values into URL search params, omitting the empty ones. */
export function encodeFilterParams(entries: Record<string, FilterValue>): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(entries)) {
    const encoded = encodeFilterValue(value);
    if (encoded !== null) params.set(key, encoded);
  }
  return params;
}
